import { render } from "./IconTitle.vue?vue&type=template&id=208909df&scoped=true&ts=true"
import script from "./IconTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./IconTitle.vue?vue&type=script&setup=true&lang=ts"

import "./IconTitle.vue?vue&type=style&index=0&id=208909df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-208909df"],['__file',"src/components/IconTitle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "208909df"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('208909df', __exports__)) {
    api.reload('208909df', __exports__)
  }
  
  module.hot.accept("./IconTitle.vue?vue&type=template&id=208909df&scoped=true&ts=true", () => {
    api.rerender('208909df', render)
  })

}


export default __exports__